import React, { useState, useEffect, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import JobList from '../job Components/JobList';
import Notification from '../../shared/Notification';
import styles from './home.module.css'; // Use CSS modules
import NavHeader from '../shared/Nav-Header';
import logo from './images/logo.jpg'
import JobSearch from '../job Components/JobSearch'; // Import the new search component



const GuestHome = () => {
    const [notification, setNotification] = useState('');
    const [jobs, setJobs] = useState([]);
    const [appliedJobs, setAppliedJobs] = useState([]);
    const [currentSlide, setCurrentSlide] = useState(0);
    const [searchActive, setSearchActive] = useState(false); // State to track if search is active
    const navigate = useNavigate();
    const token = useMemo(() => localStorage.getItem('token'), []);

    const slides = [
        {
            image: 'https://img1.wsimg.com/isteam/stock/OoYNQp/:/rs=w:3570,h:3570,mx',
            title: 'Your ONE STOP to earliest Experiences',
            subtitle: 'Discover Amazing Opportunities and KICKSTART your career journey'
        },
        {
            image: 'https://www.898marketing.com/wp-content/uploads/2022/02/Internship-Thumb.png',
            title: 'We care of APPLY you focus on what MATTERS',
            subtitle: 'TURN ON, Be Relaxed with AUTO APPLY'
        },
        {
            image: 'https://europecareers.ab-inbev.com/sites/default/files/inline-images/CheersToDreamingBig_BBG_UK_270422%20%281%29.png',
            title: 'CONNECT with your Sazz Tribe on PROJECT NETWORKS',
            subtitle: 'Find Common CONNECTIONS, Gain PARALLEL SKILLS.'
        }
    ];

    useEffect(() => {
        
        const fetchJobs = async () => {
            try {
                const response = await axios.get('/api/guest/jobs/get-all-jobs');
                setJobs(response.data);
            } catch (error) {
                // console.error('Error fetching jobs:', error);
            }
        };

        fetchJobs();
    }, [navigate]);

    // Auto-slide functionality
    useEffect(() => {
        const slideInterval = setInterval(() => {
            setCurrentSlide((prevSlide) => (prevSlide + 1) % slides.length);
        }, 10000); // Change slide every 5 seconds

        return () => clearInterval(slideInterval);
    }, [slides.length]);

    const handleApplyJob = async (jobId) => {
        // Job application logic here
    };

    const handleCloseNotification = () => {
        setNotification('');
    };

    const goToSlide = (index) => {
        setCurrentSlide(index);
    };

    const nextSlide = () => {
        setCurrentSlide((prevSlide) => (prevSlide + 1) % slides.length);
    };

    const prevSlide = () => {
        setCurrentSlide((prevSlide) => (prevSlide - 1 + slides.length) % slides.length);
    };

      // Handle jobs update from search
    const handleJobsUpdate = (searchResults) => {
        console.log('Search Results:', searchResults);
        if (searchResults.length === 0) {
            setNotification('No jobs found for the given search criteria.');
        }
        setJobs(searchResults);
        setSearchActive(true);
    };

    // Reset to default job list (you might want to load all jobs here)
    const handleClearSearch = () => {
        setSearchActive(false);
        // Load your default jobs list here
        // setJobs(defaultJobs);
    };


    return (
        <div className={styles.home}>
            <div className={styles.heroContainer}>
                {/* Background Images */}
                {slides.map((slide, index) => (
                    <div
                        key={index}
                        className={`${styles.backgroundImage} ${
                            index === currentSlide ? styles.activeSlide : ''
                        }`}
                        style={{
                            backgroundImage: `url(${slide.image})`,
                            opacity: index === currentSlide ? 1 : 0
                        }}
                    ></div>
                ))}
                
                <div className={styles.gradientOverlay}></div>
                
                <div className={styles.heroContent}>
                    <div className={styles.heroText}>
                        <h1 className={styles.heroTitle}>
                            <span className={styles.highlight}>
                                {slides[currentSlide].title}
                            </span>
                        </h1>
                        <p className={styles.heroSubtext}>
                            {slides[currentSlide].subtitle}
                        </p>
                    </div>
                </div>

                {/* Slide Navigation */}
                <div className={styles.slideNavigation}>
                    <button className={styles.navButton} onClick={prevSlide}>
                        &#8249;
                    </button>
                    <div className={styles.slideIndicators}>
                        {slides.map((_, index) => (
                            <button
                                key={index}
                                className={`${styles.indicator} ${
                                    index === currentSlide ? styles.activeIndicator : ''
                                }`}
                                onClick={() => goToSlide(index)}
                            ></button>
                        ))}
                    </div>
                    <button className={styles.navButton} onClick={nextSlide}>
                        &#8250;
                    </button>
                </div>
            </div>
            
            <NavHeader />
            
            {notification && (
                <Notification message={notification} onClose={handleCloseNotification} />
            )}
                {/* Add the search component */}
            {/* <div className={styles.jobSearch}>
            <JobSearch onJobsUpdate={handleJobsUpdate} /> 
            
            {searchActive && (
            <button onClick={handleClearSearch} className={styles.clearSearchBtn}>
                Clear Search
            </button>
            )} 
            </div> */}
            <div className={styles.content}>
                <JobList jobs={jobs} appliedJobs={appliedJobs} onApplyJob={handleApplyJob} />
            </div>
        </div>
    );
};

export default GuestHome;